import React from 'react';
import { Styled } from './container.style';

export const Container: React.FC = ({ children }) => {
  return <Styled.Container p={3}>{children}</Styled.Container>;
};
